import { useDispatch, useSelector } from 'react-redux';
import { showErrorModal } from '../../global-message/global-message-actions';
import styles from './nativeShareButton.module.less';
import { useProject } from '../project-hooks/useProject';
import { webShare } from './share-utils';
import { PrimaryButton, SecondaryButton } from '@sb1/ffe-buttons-react';

const NativeShareButton = ({
    text,
    urlToShare,
    titleToShare,
    trackEventFunction,
    shareWithPicture = true,
    onBack,
    className,
}) => {
    const dispatch = useDispatch();
    const project = useProject();
    const baseURL = useSelector((state) => state.baseURL);
    const projectId = project.id;

    const urlToImageToShare = shareWithPicture ? `${baseURL}/api/public/project/${projectId}/shareImage` : '';

    return (
        <div className={className || styles.nativeShare}>
            <div className={styles.buttons}>
                {onBack && <SecondaryButton onClick={onBack}>Tilbake</SecondaryButton>}
                <PrimaryButton
                    onClick={async () => {
                        trackEventFunction && trackEventFunction();
                        await webShare({ urlToShare, titleToShare, urlToImageToShare }).catch((err) => {
                            if (!err.toString().includes('AbortError')) {
                                dispatch(showErrorModal('Klarte ikke å dele.'));
                            }
                        });
                    }}
                >
                    {text || 'Del spleisen'}
                </PrimaryButton>
            </div>
        </div>
    );
};

export default NativeShareButton;
